import { Variant as TypographyVariant } from '@mui/material/styles/createTypography'
import { QuoteStatus } from './QuoteData'
import { InsurancePlanType } from './InsurancePlan'

export type ViewName =
  | 'intro'
  | 'insurance-information'
  | 'insurers'
  | 'select-prescription'
  | 'select-product'
  | 'review'
  | 'quote'
  | 'start'

type ViewNavigation = {
  previous?: ViewName
  next?: ViewName
}

export type ResumeToViewOptions = {
  quoteStatus?: QuoteStatus
  hasPrescription?: boolean
  hasReferrer?: boolean
}

export type RxHelpGuideOptions = {
  hideGlasses?: boolean
  hideContacts?: boolean
  hideHowToRead?: boolean
  hidePhotos?: boolean

  glassesrx?: {
    enableWhatSection?: boolean
    enablePrismSection?: boolean
  }
}

export type PageFlowConfiguration = {
  defaultView: 'intro' | 'insurance-information'
  loginRedirectView?: 'intro' | 'start'
  flow: Record<ViewName, ViewNavigation>
  steps: ViewName[]

  // max steps will be calculated based on steps list and number of dynamic insurance forms
  maxSteps?: number

  // show or hide step x of y on form
  showSteps: boolean

  // additional steps from number of dynamic insurance forms
  stepsOffset: number

  // mapping of in progress claim record status to view
  // claim record status may have qualifier suffix such as :HAS_PRESCRIPTION
  // e.g. QUOTE_REQUIRED --> quote
  resumeMapping?: Record<string, ViewName | QuoteStatusViewMap>

  // view specific options
  options?: Record<ViewName, ViewOptions>

  modalOptions?: ModalOptions

  footerConfiguration?: Record<ViewName | '*', FooterConfiguration>

  tooltip?: TooltipConfiguration

  benefitPlanConfiguration?: {
    displayOrder: InsurancePlanType[]
  }

  rxhelpGuide?: RxHelpGuideOptions
}

export interface QuoteStatusViewMap {
  quoteStatusMap: Record<QuoteStatus | '*', ViewName>
}

export interface Step {
  stepNumber?: number
  stepId: string
  stepTitle?: string
}

export interface ViewOptions {
  promptUnsavedChanges: boolean
  benefitPlanOrder?: InsurancePlanType[]
}

export interface ConfigurableCtaOptions {
  renderAs?: 'link' | 'button'
  underline?: boolean
  showIcon?: boolean
  icon?: string
  typographyVariant?: TypographyVariant
  typographyColor?: string
  variant?: 'primary' | 'secondary'
  sx?: Record<string, unknown>
  componentProps?: object
}

export interface ModalOptions {
  textAlign?: 'left' | 'right' | 'center'
  primaryCta?: ConfigurableCtaOptions
  secondaryCta?: ConfigurableCtaOptions
}

export interface FooterConfiguration {
  cancelCta?: ConfigurableCtaOptions
  submitCta?: ConfigurableCtaOptions
}

export type TooltipConfiguration = {
  clickable?: boolean
}

export enum AppCloseAction {
  NONE,
  CANCEL,
  CLOSE_APP,
}
